<template>
  <ListItem clickable>
    <ListSection>
      <ListLabel v-if="label">
        {{ label }}
      </ListLabel>
      <ListLabel
        v-if="description"
        caption
      >
        {{ description }}
      </ListLabel>
    </ListSection>
    <ListSection side>
      <slot name="action" />
    </ListSection>
  </ListItem>
</template>

<script setup>
import ListItem from '@/components/ui/List/ListItem.vue'
import ListSection from '@/components/ui/List/ListSection.vue'
import ListLabel from '@/components/ui/List/ListLabel.vue'

defineOptions({ name: 'SettingsListItem' })
defineProps({
  label: { type: String, required: true },
  description: { type: String, default: undefined }
})
</script>
